import { formatThousand } from "@/utils/util";
import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";

export const ItemBox = ({ img, title, postage, cupPoints }) => {
  const { t } = useTranslation("mall");

  return (
    <div className="bg-black rounded-[16px] py-[8px] pl-[8px] pr-[16px] relative flex text-white">
      <div className="w-[80px] h-[80px] relative bg-white rounded-[8px]">
        <Image src={img} layout="fill" alt="" />
      </div>

      <div className="ml-[12px]">
        <div className="text-[14px] font-bold leading-[22px]">{title}</div>

        <div className="absolute flex items-end right-[16px] bottom-[10px]">
          <span className="mr-[8px]">{t("cuppoints")}</span>

          {postage > 0 && (
            <div className="flex items-center mr-[4px] text-[12px] text-[#FF2800] h-[18px] border border-solid border-[#FF2800] px-[6px] rounded-[4px]">
              {t("postageBadge")}
              &nbsp;
              {postage}
            </div>
          )}

          <span className="text-[#FF2800] text-[20px] leading-none font-bold">
            {formatThousand(cupPoints)}
          </span>
        </div>
      </div>
    </div>
  );
};
